import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function RequireAuth({ children, role }) {
    const { token, user, loading } = useSelector((state) => state.auth);

    //console.log("RequireAuth render, token:", token, "user:", user, "loading:", loading);

    // Kalau sedang ambil profile, tunggu dulu
    if (loading) {
        return <div className="p-6">Loading...</div>;
    }

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // Jangan cek role kalau user belum ada
    if (role && user && user.role !== role) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
}